import { Component } from '@angular/core';
import { Organization, OrganizationsGQL } from '../../../../../../graphql/generated';
import { toSignal } from '@angular/core/rxjs-interop';
import { LucideChevronRight } from '@lucide/angular';
import { AutoAnimateDirective } from '../../../../shared/directives/auto-animate.directive';
import { SpinnerComponent } from '@knalgeel/pandora';
import { IconComponent } from '../../../../shared/components/icon/icon.component';

@Component({
    selector: 'app-organization-picker',
    templateUrl: './organization-picker.component.html',
    styleUrl: './organization-picker.component.scss',
    imports: [AutoAnimateDirective, IconComponent, SpinnerComponent],
})
export class OrganizationPickerComponent {

    protected readonly chevronIcon = LucideChevronRight;

    organizations = toSignal(this.organizationsGQL.watch().valueChanges);

    constructor(
        private readonly organizationsGQL: OrganizationsGQL
    ) {
    }

    onClickListItem(organization: Organization) {
        // If port is another port than 80 or 443, we need to include it in the URL.
        // Otherwise, we can leave it out.
        const port = this.port === '80' || this.port === '443' ? '' : `:${this.port}`;

        // Redirect to the organization's subdomain. it is alwaty

        window.location.href = `${this.protocol}//${organization.subdomain}.${this.currentApexDomain}${port}`;
    }

    private get protocol() {
        return window.location.protocol;
    }

    private get port() {
        return window.location.port;
    }

    private get currentApexDomain() {
        if (window.location.hostname === 'localhost') {
            return window.location.hostname;
        }

        // if the hostname is localhost, we can return it as is.
        // Otherwise, we need to remove the first part of the hostname, if there are more than 2 parts.
        // For example, if the hostname is 'subdomain.example.com', we need to return 'example.com'.

        const parts = window.location.hostname.split('.');
        if (parts.length > 2) {
            return parts.slice(1).join('.');
        }

        return window.location.hostname;
    }
}
